















































import {Component, Vue, Watch} from 'vue-property-decorator';
import {eventService} from './services/event-service';
import Navbar from '@/components/Navbar.vue';
import Spinner from '@/components/Spinner.vue';
import Home from '@/views/Home.vue';

@Component({
  components: { Navbar, Home, Spinner }
})
export default class App extends Vue {
  private spinner:boolean = false;

  created () {
    eventService.subscribe("showSpinner", () => {
      this.spinner = true;
    });
    eventService.subscribe("hideSpinner", () => this.spinner = false);
  }

}
